module.exports = __webpack_public_path__ + "img/20_14.de087b45.png";